import _ from 'lodash'

const DomHelper = class DomHelper {
  static hideElement (el) {
    setTimeout(function () {
      el.style.display = 'none'
    }, 0)
  }

  static displayElement (el) {
    setTimeout(function () {
      el.style.display = 'block'
    }, 0)
  }

  static applyStyleToElement (el, style) {
    Object.assign(el.style, style)
  }

  static scaleElement (el, scale) {
    el.style.transform = `scale(${scale})`
  }

  static resetElementScale (el) {
    el.style.transform = ''
  }

  static playPulseScaleAnimation (el) {
    setTimeout(() => {
      el.classList.add('vbm--animate-pulse-scale')
    }, 200)

    setTimeout(() => {
      el.classList.remove('vbm--animate-pulse-scale')
    }, 700)
  }

  static getMinSizeOfElement (el) {
    return Math.min(el.clientHeight, el.clientWidth)
  }

  static getMinSizeOfContentRect (contentRect) {
    if (_.isNull(contentRect)) return 0
    return Math.min(contentRect.height, contentRect.width)
  }
}

export default DomHelper
